type DockLinkProps = {
	href: string;
	icon: string;
	target?: string;
	label: string;
};

export const GITHUB_LINK: DockLinkProps = {
	href: '/github',
	icon: 'line-md:github-loop',
	target: '_blank',
	label: 'GitHub',
};

export function goToTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}
